// Maps a `complete` mutation `ApiError` to the Italian copy shown
// inside the in-form Banner. Branches on the BE domain code emitted by
// `auth-provisioning.routes.ts mapDomainErrorToResponse`. Generic
// fallback for unknown codes / non-ApiError throws.

import { ApiError } from '@/lib/envelope';
import { MIN_PASSWORD_LENGTH } from '../lib/password-validation';

export function CompleteErrorMessage({ error }: { error: unknown }): JSX.Element {
  if (!(error instanceof ApiError)) {
    return <span>Si è verificato un errore. Riprova.</span>;
  }
  switch (error.code) {
    case 'USER_PROVISIONING_TOKEN_NOT_FOUND':
      return <span>Il link non è valido. Apri di nuovo l’email da Aurino Broker.</span>;
    case 'USER_PROVISIONING_TOKEN_EXPIRED':
    case 'USER_PROVISIONING_TOKEN_CONSUMED':
      return (
        <span>Il link è scaduto o è già stato utilizzato. Richiedi un nuovo invito.</span>
      );
    case 'USER_PROVISIONING_PASSWORD_TOO_SHORT':
      return (
        <span>
          La password deve contenere almeno {MIN_PASSWORD_LENGTH} caratteri.
        </span>
      );
    case 'USER_PROVISIONING_PASSWORD_CONTAINS_EMAIL':
      return <span>La password non può contenere la tua email.</span>;
    case 'USER_PROVISIONING_PASSWORD_CONTAINS_NAME':
      return <span>La password non può coincidere con il tuo nome completo.</span>;
    case 'VALIDATION_FAILED':
      return <span>Dati non validi. Verifica i campi e riprova.</span>;
    case 'USER_PROVISIONING_FIREBASE_FAILED':
    case 'USER_PROVISIONING_DB_WRITE_FAILED':
      return (
        <span>
          Errore tecnico durante il salvataggio. Riprova tra qualche minuto.
        </span>
      );
    default:
      return <span>{error.message || 'Si è verificato un errore. Riprova.'}</span>;
  }
}
